"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _ui = require("@probeton/ui");

var _pocUi = require("@solar/poc-ui");

var _solarReact = require("@solar/solar-react");

var _solarReact2 = require("@probeton/solar-react");

var _CreateFabricateDialog = _interopRequireDefault(require("./CreateFabricateDialog"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    fab: {
      position: 'absolute',
      bottom: theme.spacing.unit * 2,
      right: theme.spacing.unit * 2
    }
  };
});

var CertificateFabricates = function CertificateFabricates(_ref) {
  var _ref$fabricates = _ref.fabricates,
      fabricates = _ref$fabricates === void 0 ? [] : _ref$fabricates,
      certificate = _ref.certificate,
      product = _ref.product,
      createFabricate = _ref.createFabricate,
      openFabricate = _ref.openFabricate,
      labels = _ref.labels;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = (0, _react.useState)('all'),
      _useState4 = _slicedToArray(_useState3, 2),
      filter = _useState4[0],
      setFilter = _useState4[1];

  var filteredFabricates = (0, _react.useMemo)(function () {
    if (filter === 'all') {
      return fabricates;
    }

    return fabricates.filter(function (fab) {
      return filter === 'valid' && (fab.isValid === undefined || fab.isValid) || filter === 'invalid' && fab.isValid === false;
    });
  }, [filter, fabricates]); // console.log({ certificate, product, fabricates, types: certificate.productTypes || [] });

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, fabricates.length > 0 ? /*#__PURE__*/_react["default"].createElement(_solarReact2.ResponsiveSheet, {
    noPadding: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Tabs, {
    value: filter,
    onChange: function onChange(ev, value) {
      setFilter(value);
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Tab, {
    value: "all",
    label: "all"
  }), /*#__PURE__*/_react["default"].createElement(_core.Tab, {
    value: "valid",
    label: "only valid"
  }), /*#__PURE__*/_react["default"].createElement(_core.Tab, {
    value: "invalid",
    label: "only invalid"
  })), /*#__PURE__*/_react["default"].createElement(_core.List, null, filteredFabricates.map(function (_ref2) {
    var _id = _ref2._id,
        name = _ref2.name,
        code = _ref2.code;
    return /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
      textLabel: name,
      text: code,
      interactive: true,
      onClick: function onClick() {
        return openFabricate(_id);
      }
    });
  }))) : /*#__PURE__*/_react["default"].createElement(_solarReact.EmptyState, {
    Icon: _Add["default"],
    label: labels.empty
  }), !product.publishedFormSchema && /*#__PURE__*/_react["default"].createElement(_solarReact.EmptyState, {
    Icon: _Add["default"],
    label: "You can't create new fabricates for this certificate yet. We're stil working on the data structure for the products in this certificate."
  }), !!product.publishedFormSchema && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Zoom, {
    "in": true,
    timeout: 500,
    style: {
      transitionDelay: '600ms'
    },
    unmountOnExit: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Fab, {
    classes: {
      root: classes.fab
    },
    color: "primary",
    onClick: function onClick() {
      return setIsOpen(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Add["default"], null))), /*#__PURE__*/_react["default"].createElement(_CreateFabricateDialog["default"], {
    certificate: certificate,
    product: product,
    createFabricate: createFabricate,
    labels: labels,
    open: isOpen,
    onClose: function onClose() {
      return setIsOpen(false);
    },
    types: certificate.productTypes || []
  })));
};

var _default = CertificateFabricates;
exports["default"] = _default;